<template>
<div class="financing_data">
  <!-- 热点领域 融资事件 -->
  <div class="chart_bg">
    <div class="title">
      <span class="chart_name">热点领域（数量）
        <Poptip class="poptip_event" v-model="pop_tip" placement="bottom-start" word-wrap v-if="!spinShow">
          <div class="i-container"><i class="iconfont">&#xe668;</i></div>
          <div slot="content">
              <p><span>提示</span><i class="iconfont" @click="pop_tip=false">&#xe6c2;</i></p>
              <p>若公司业务涉及多个细分领域，其获得融资时，则该页面多个细分领域会同时计数（事件数、融资额）</p>
          </div>
        </Poptip>
      </span>

      <div class="condition">
        <div class="time_sel">
          <Dropdown @on-click="haddleChangeYQ">
            <a href="javascript:void(0)">{{params.count_type == '2' ? '季度' : '年度'}}</a>
            <DropdownMenu slot="list">
              <DropdownItem name="1" :disabled="params.count_type == '1'">年度</DropdownItem>
              <DropdownItem name="2" :disabled="params.count_type == '2'">季度</DropdownItem>
            </DropdownMenu>
          </Dropdown>
        </div>
        <div class="location">
          <AddressTab @selectAddress="addressChecked"></AddressTab>
        </div>
        <!-- <div class="upload">
          <a @click="haddleSave"><i class="iconfont">&#xe644;</i>下载</a>
        </div> -->
      </div>
    </div>

    <div class="hot_container">
      <div class="hot_cnt" id="up_img">
        <ul class="hot_xf">
          <li @click="changely('' ,'全部')">
            <span :class="{'active': params.tag_arr.length == 0}">全部</span>
          </li>
          <li @click="changely(x.id, x.name)" v-for="(x,index) in tagmap" :key="x.id + '_' + index">
            <!-- <Tooltip placement="top" v-if="x.name.length > 6">
              <span :class="{'active': params.tag_arr.findIndex(a => x.id == a) > -1}">{{spliceString(x.name, 5)}}</span>
              <div slot="content">
                <p>{{x.name}}</p>
              </div>
            </Tooltip> -->
            <span :class="{'active': params.tag_arr.findIndex(a => x.id == a) > -1}">{{x.name}}</span>
          </li>
          <li>
            <span v-if="params.tag_arr.length == 0">总数</span>
          </li>
          <li></li>
          <li></li>
        </ul>
        <div class="hot_nr">
          <!-- 按年 -->
          <div class="hot-chart" v-if="params.count_type == '1' && params.tag_arr.length == 0 && can_render">
            <div class="hot-div-li">
              <div v-for="(xa, index) in x_axis" :key="xa" class="hot_rli">
                <ul>
                  <li></li>
                  <Tooltip placement="top" v-for="(x, idx) in tagmap" :key="xa + x.id + idx">
                    <li :style="{ 'background': showHex(hot_list[xa][x.name]) }" @click="haddleTableCell(xa, x)">
                      {{hot_list[xa][x.name]}}
                    </li>
                    <div slot="content">
                      <p class="p1">{{x.name}}</p>
                      <p class="p2">融资事件：<span>{{hot_list[xa][x.name]}}起</span></p>
                    </div>
                  </Tooltip>
                  <!-- <Tooltip class="last-li" placement="top" v-if="transString(hot_list[xa]['sum']).length>4">
                                      <li>{{spliceString(transString(hot_list[xa]['sum']), 4)}}</li>
                                      <div slot="content">
                                        <p class="p1">总数:{{hot_list[xa]['sum']}}</p>
                                      </div>
                                    </Tooltip> -->
                  <li>{{hot_list[xa]['sum']}}</li>
                </ul>
              </div>
            </div>
            <div class="hot-year hot-year1">
              <div class="hot-year-item" :class="{'hot-year-item-color':params.tag_arr.length > 0}" v-for="(x, idx) in x_axis" :key="x">{{x}}</div>
            </div>
          </div>
          <!-- 按季度 -->
          <div class="hot-chart" v-if="params.count_type == '2' && params.tag_arr.length == 0 && can_render">
            <div class="hot-div-li">
              <div v-for="(xa, index) in x_axis" :key="xa.year" class="hot-div-li-q hot_rli">
                <ul v-for="q in xa.q_arr">
                  <li></li>
                  <Tooltip placement="top" v-for="(x, idx) in tagmap" :key="xa.year + q + x.id + idx">
                    <li :style="{ 'background': showHex(hot_list[xa.year][q][x.name]) }" @click="haddleTableCell(xa, x)">
                      <!-- {{hot_list[xa.year][q][x.name]}} -->
                    </li>
                    <div slot="content">
                      <p class="p1">{{x.name}}</p>
                      <p class="p2">融资事件：<span>{{hot_list[xa.year][q][x.name]}}起</span></p>
                    </div>
                  </Tooltip>
                  <!-- <li>{{hot_list[xa.year][q]['sum']}}</li> -->
                  <Tooltip class="last-li" placement="top" v-if="transString(hot_list[xa.year][q]['sum']).length>4">
                    <li>{{spliceString(transString(hot_list[xa.year][q]['sum']), 4)}}</li>
                    <div slot="content">
                      <p class="p1">总数:{{hot_list[xa.year][q]['sum']}}</p>
                    </div>
                  </Tooltip>
                  <li v-else>{{hot_list[xa.year][q]['sum']}}</li>
                </ul>
              </div>
            </div>
            <div class="hot-year hot-year2">
              <div class="hot-year-item hot-year-item-left" v-for="(xa, index) in x_axis">
                <div v-for="q in xa.q_arr">
                  {{q}}
                </div>
              </div>
            </div>
            <div class="hot-year hot-year1">
              <div class="hot-year-item hot-year-item-left" v-for="(x, idx) in x_axis">
                {{x.year}}
              </div>
            </div>
          </div>
          <div class="hot_e" v-if="params.tag_arr.length == 1">
            <div class="chart current-hot" id="chart9"></div>
          </div>
          <div class="hot_e" v-if="params.tag_arr.length > 1">
            <div class="chart current-hot" id="arr_chart0"></div>
          </div>
          <Spin fix v-if="!can_render">
            <Icon type="ios-loading" size=18 class="demo-spin-icon-load"></Icon>
            <div>Loading</div>
          </Spin>
        </div>
      </div>
      <div class="time_slier">
        <Slider v-model="years" range :min="2011" :step="0.01" :tip-format="sliderTipFormat" :max="moment_year" @on-change="hadleTimeSlider" class="year_slider"></Slider>
        <div style="slier_axis" class="slier_axis">
          <span v-for="item,index in slier_axis" :key="item"  :style="'left:' + (100 / (slier_axis.length - 1)) * index + '%'">{{item}}</span>
        </div>
      </div>
    </div>
    <p class="data_src"><span>数据来源：动脉橙数据库</span><span>数据截止时间：{{today}}</span></p>
  </div>
  <div class="top-tip">全部<span>（{{total}}）</span>
    <Dropdown @on-click="haddleChangeSort">
      <a href="javascript:void(0)">{{sort_id | dealName(sort_list)}}<i class="iconfont">&#xe6ea;</i></a>
      <DropdownMenu slot="list">
        <DropdownItem v-for="item in sort_list" :key="item.id" :name="item.id" :disabled="sort_id === item.id">{{item.name}}</DropdownItem>
      </DropdownMenu>
    </Dropdown>
  </div>
  <div class="list_div">
    <Table :columns="columns" :data="list"></Table>
    <div class="page clear" v-if="total > 10">
      <Page :total="total" :page-size="10" :current="list_params.page" class="page_list" show-total show-elevator @on-change="handleChangePage" ref="pages" />
    </div>
  </div>
  <Contanct></Contanct>
  <DownloadCharts v-if="visible" :visible="visible" :imgbase="imgbase" :tabTitle="name" :pageTitle="page_title" :params="params" @closeecharts="closeEcharts"></DownloadCharts>
  <Spin fix v-if="spinShow">
    <Icon type="ios-loading" size=18 class="demo-spin-icon-load"></Icon>
    <div>Loading</div>
  </Spin>
  <VipPrompt :pageModal="page_modal" @pagecancel="pageCancel">
    <p class="p1">亲，热点领域支持多个领域对比啦~</p>
    <p class="p2">普通用户仅2个，VIP会员数量更多</p>
  </VipPrompt>
</div>
</template>

<script>
import filter from 'js/filter'
import Contanct from '../Contanct'
import AddressTab from '../AddressTab'
import DownloadCharts from '../DownloadCharts2'
import VipPrompt from '@/components/VipPrompt.vue'
import {
  userInfo
} from 'js/userInfo'
import {
  financing_common
} from 'js/financing_mixins'
import {
  hex_mixin
} from 'js/hex_mixins'
import echarts from 'echarts'
import {
  option1, option8
} from 'js/financing_chart'
import {
  hottagOfCountMap, hotTagOfEventList
} from '../../../../service'
import moment from 'moment'
import html2canvas from 'html2canvas'

export default {
  mixins: [financing_common, hex_mixin, userInfo],
  props: ['tagmap'],
  components: {
    Contanct,
    AddressTab,
    DownloadCharts,
    VipPrompt
  },
  data() {
    return {
      pop_tip: true,
      page_title: '当前热点领域',
      name: '融资事件',
      option: option1, // chart图使用配置5
      arr_option: option8,
      list: [], // 表格数据
      list_params: {
        user_key: this.$store.state.user_key,
        page: 1,
        sort_type: 0,
        demostic: '',
        address_id: '',
        other_address: [],
        s_time: 2011,
        e_time: parseInt(moment().format('YYYY')),
        round_ids: [],
        tag_arr: []
      },
      params: { // 请求参数
        user_key: this.$store.state.user_key,
        demostic: '',
        address_id: '',
        other_address: [],
        s_time: 2011,
        e_time: parseInt(moment().format('YYYY')),
        count_type: 1,
        tag_arr: []
      },
      x_axis: [], // 图表X轴
      y_axis: [], // 图表Y轴
      hot_list: {},
      can_render: false, // 监听是否可以开始渲染
    }
  },
  methods: {
    async getMap() {
      this.curInt = ''
      this.can_render = false
      let res = await hottagOfCountMap(this.params, (error) => {
        this.$Message.error('请求错误！')
      })
      if (res.status == 'success') {
        if (this.is_destroyed) {
          return false
        }
        this.x_axis = []
        // 列表数据
        let chart_data = res.res // chart_data图表原数据
        this.hot_list = {}
        if (this.params.tag_arr.length == 0) { // 全部
          let max_num = 0, min_num = 0
          if (this.params.count_type == 1) { // 按年
            this.x_axis = this.time_axis //X轴
            // 遍历图表数据空结构
            this.x_axis.map((a) => {
              this.hot_list[a] = {}
              this.tagmap.map((b) => {
                this.hot_list[a][b.name] = 0
                this.hot_list[a]['sum'] = 0
              })
            })
            chart_data.map((a) => {
              let tag_name = filter.dealName(a.tag_id, this.tagmap)
              this.hot_list[a.e_time_year][tag_name] = a.total
              this.hot_list[a.e_time_year]['sum'] += Number(a.total)
              max_num = Math.max(max_num, Number(a.total))
              min_num = Math.min(min_num, Number(a.total))
            })
          } else {
            this.time_axis.map((a) => {
              this.x_axis.push({
                year: a,
                q_arr: ['Q1', 'Q2', 'Q3', 'Q4']
              })
              this.hot_list[a] = {
                Q1: {},
                Q2: {},
                Q3: {},
                Q4: {}
              }
              this.tagmap.map((b) => {
                this.hot_list[a]['Q1'][b.name] = 0
                this.hot_list[a]['Q1']['sum'] = 0

                this.hot_list[a]['Q2'][b.name] = 0
                this.hot_list[a]['Q2']['sum'] = 0

                this.hot_list[a]['Q3'][b.name] = 0
                this.hot_list[a]['Q3']['sum'] = 0

                this.hot_list[a]['Q4'][b.name] = 0
                this.hot_list[a]['Q4']['sum'] = 0
              })
            })
            chart_data.map((a) => {
              let tag_name = filter.dealName(a.tag_id, this.tagmap)
              this.hot_list[a.e_time_year]['Q' + a.Q_num][tag_name] = a.total
              this.hot_list[a.e_time_year]['Q' + a.Q_num]['sum'] += Number(a.total)
              max_num = Math.max(max_num, Number(a.total))
              min_num = Math.min(min_num, Number(a.total))
            })
          }
          this.min_max_num = [min_num, max_num]
        } else if (this.params.tag_arr.length == 1){
          var chart = echarts.init(document.getElementById('chart9'), 'macarons')
          this.option.legend.data = ['事件数', '增长率']
          this.option.series[0].name = '事件数'
          this.option.series[1].name = '增长率'

          let growth_rate = [],
            event_count = [],
            quarter_arr = []
          if (this.params.count_type == 1) { //按年
            this.time_axis.map((a) => {
              let index = chart_data.findIndex(b => a == b.e_time_year)
              if (index > -1) {
                growth_rate.push(filter.floatNumber(chart_data[index].growth_rate))
                event_count.push(chart_data[index].total)
              } else {
                growth_rate.push(0)
                event_count.push(0)
              }
            })
            this.option.xAxis[0].data = this.time_axis
            this.option.xAxis[0].axisLabel.textStyle.color = '#BCBDC1'
            this.option.xAxis[1].show = false
            this.option.grid.bottom = '10px'
            this.option.series[0].barWidth = 30
            this.option.series[0].label.normal.show = true
            this.option.series[1].label.normal.show = true

            chart.off('click')
            chart.on('click', (params) => {
              this.haddleClickChart1(params)
              chart.setOption(this.option)
            })

          } else { //按季度
            this.time_axis.map((a) => {
              quarter_arr.push('Q1')
              quarter_arr.push('Q2')
              quarter_arr.push('Q3')
              quarter_arr.push('Q4')
              let index1 = chart_data.findIndex((b) => {
                return a == b.e_time_year && b.Q_num == 1
              })
              if (index1 > -1) {
                growth_rate.push(filter.floatNumber(chart_data[index1].growth_rate))
                event_count.push(chart_data[index1].total)
              } else {
                growth_rate.push(0)
                event_count.push(0)
              }

              let index2 = chart_data.findIndex((b) => {
                return a == b.e_time_year && b.Q_num == 2
              })
              if (index2 > -1) {
                growth_rate.push(filter.floatNumber(chart_data[index2].growth_rate))
                event_count.push(chart_data[index2].total)
              } else {
                growth_rate.push(0)
                event_count.push(0)
              }

              let index3 = chart_data.findIndex((b) => {
                return a == b.e_time_year && b.Q_num == 3
              })
              if (index3 > -1) {
                growth_rate.push(filter.floatNumber(chart_data[index3].growth_rate))
                event_count.push(chart_data[index3].total)
              } else {
                growth_rate.push(0)
                event_count.push(0)
              }

              let index4 = chart_data.findIndex((b) => {
                return a == b.e_time_year && b.Q_num == 4
              })
              if (index4 > -1) {
                growth_rate.push(filter.floatNumber(chart_data[index4].growth_rate))
                event_count.push(chart_data[index4].total)
              } else {
                growth_rate.push(0)
                event_count.push(0)
              }
            })
            this.option.xAxis[0].data = quarter_arr
            this.option.xAxis[1].show = true
            this.option.grid.bottom = '20px'
            this.option.series[0].barWidth = 18
            this.option.series[0].label.normal.show = false
            this.option.series[1].label.normal.show = false
            chart.off('click')
          }
          this.option.xAxis[1].data = this.time_axis
          this.option.series[0].data = event_count
          this.option.series[1].data = growth_rate
          this.echartChangeTheme4()
          chart.clear()
          chart.setOption(this.option)
          this.mychart = chart
        } else if (this.params.tag_arr.length > 1){
          // arr_option
          let chart = echarts.init(document.getElementById('arr_chart0'))
          let quarter_arr = [],
              legend_arr = [],
              series_arr = []
          this.params.tag_arr.map((a,index) => {
            legend_arr.push(filter.dealName(a, this.tagmap))
            series_arr.push({
              name: filter.dealName(a, this.tagmap),
              type: 'line',
              data: [],
              label: { normal: { show: false, color: '' }},
              itemStyle: { normal: { color: '' }},
              lineStyle: { normal: { color: '' }}
            })
          })

          this.arr_option.legend.data = legend_arr
          this.arr_option.series = series_arr

          if (this.params.count_type == 1) { //按年
            this.arr_option.xAxis[0].data = this.time_axis
            this.arr_option.xAxis[1].show = false
            this.arr_option.grid.bottom = '10px'
            this.params.tag_arr.map((a,i) => {
              let y_even = []
              this.time_axis.map(b => {
                let index = chart_data.findIndex(c => b == c.e_time_year && a == c.tag_id)
                if (index > -1) {
                  y_even.push(chart_data[index].total)
                } else {
                  y_even.push(0)
                }
              })
              this.arr_option.series[i].data = y_even
              this.arr_option.series[i].label.normal.color = this.legend_colors[i]
              this.arr_option.series[i].itemStyle.normal.color = this.legend_colors[i]
              this.arr_option.series[i].lineStyle.normal.color = this.legend_colors[i]
            })
          }
          else { //按季度
            this.time_axis.map((a) => {
              quarter_arr.push('Q1')
              quarter_arr.push('Q2')
              quarter_arr.push('Q3')
              quarter_arr.push('Q4')
            })
            this.arr_option.xAxis[0].data = quarter_arr
            this.arr_option.xAxis[1].show = true
            this.arr_option.grid.bottom = '20px'
            this.params.tag_arr.map((a,index) => {
              let q_event = []
              let item = res.res.find(b => b.tag_id == a)
              this.time_axis.map(b => {
                let index1 = chart_data.findIndex(c => {
                  return b == c.e_time_year && c.Q_num == 1 && a == c.tag_id
                })
                if (index1 > -1) {
                  q_event.push(chart_data[index1].total)
                } else {
                  q_event.push(0)
                }

                let index2 = chart_data.findIndex(c => {
                  return b == c.e_time_year && c.Q_num == 2 && a == c.tag_id
                })
                if (index2 > -1) {
                  q_event.push(chart_data[index2].total)
                } else {
                  q_event.push(0)
                }

                let index3 = chart_data.findIndex(c => {
                  return b == c.e_time_year && c.Q_num == 3 && a == c.tag_id
                })
                if (index3 > -1) {
                  q_event.push(chart_data[index3].total)
                } else {
                  q_event.push(0)
                }

                let index4 = chart_data.findIndex(c => {
                  return b == c.e_time_year && c.Q_num == 4 && a == c.tag_id
                })
                if (index4 > -1) {
                  q_event.push(chart_data[index4].total)
                } else {
                  q_event.push(0)
                }
              })
              this.arr_option.series[index].data = q_event
              this.arr_option.series[index].label.normal.color = this.legend_colors[index]
              this.arr_option.series[index].itemStyle.normal.color = this.legend_colors[index]
              this.arr_option.series[index].lineStyle.normal.color = this.legend_colors[index]
            })
          }
          this.arr_option.xAxis[1].data = this.time_axis
          this.arr_option = JSON.parse(JSON.stringify(this.arr_option))
          this.echartChangeTheme6()
          chart.clear()
          chart.off('click')
          this.arr_option.legend.formatter = (params => {
            return params.split('|')[0]
          })
          this.arr_option.tooltip.formatter = (params => {
            let name = params[0].name,
              seriesName = params[0].seriesName,
              title = '',
              html = ''
            if (this.params.count_type == 1) {
              title = `<p class="p1">` + name + `年</p>`
            } else {
              let start_y = Number(this.time_axis[0]),
                  y = start_y + Math.ceil((params[0].dataIndex + 1)/4) - 1
              title = `<p class="p1">` + y + `年`+name+`</p>`
            }

            params.map(a => {
              html = html + `<p class="p2"><i class="cir_i" style="background-color: ` + a.color + `"></i>` + a.seriesName.split('|')[0] + `：<span>` + a.value + `起</span></p>`
            })
            return `<div class="chart_tip">` + title + html + `</div>`
          })
          chart.clear()
          chart.setOption(this.arr_option)
          this.mychart = chart
        }
        
        this.can_render = true
        this.spinShow = false
      } else {
        this.$Message.error(res.msg)
      }
    },
    async getList() {
      let res = await hotTagOfEventList(this.list_params, (error) => {
        this.$Message.error('请求错误！')
      })
      if (res.status == 'success') {
        // 列表数据
        this.$set(this.$data, 'list', res.res)
        if (this.list_params.page == 1) {
          this.$set(this.$data, 'total', res.count)
        }
      } else {
        this.$Message.error(res.msg)
      }
    },
    changely(tag_id, tag_name) {
      _czc.push(['_trackEvent', '投融资页面', this.page_title + '_' + this.name + '细分领域点击（' + tag_name + '）'])
      if (this.user_key) {
        if (tag_id == '') {
          this.years = [2011, this.moment_year]
          this.params.s_time = 2011
          this.params.e_time = this.moment_year
          this.list_params.s_time = 2011
          this.list_params.e_time = this.moment_year
          this.params.tag_arr = []
          this.list_params.tag_arr = []
        } else {
          let len = this.params.tag_arr.length
          let index = this.params.tag_arr.findIndex(a => a == tag_id)
          if (index == -1) {
            if (len == 2 && !this.is_vip) {
              this.page_modal = true
              return false
            }
            if (len == 5 && this.is_vip) {
              this.$Message.warning('只能选择5种领域');
              return false
            }
            this.params.tag_arr.push(tag_id)
            this.list_params.tag_arr.push(tag_id)
          } else {
            this.params.tag_arr.splice(index, 1)
            this.list_params.tag_arr.splice(index, 1)
          }
        }
        this.list_params.page = 1
        this.getMap()
        this.getList()
      } else {
        this.login()
      }
    },
    haddleSave() {
      _czc.push(['_trackEvent', '投融资页面', this.page_title + '_' + this.name + '下载点击'])
      this.loginVipFlow(() => {
        html2canvas(document.getElementById('up_img'), {
          scale: 1,
          backgroundColor: !this.theme_switch ? '#2A2F42' : '#ffffff',
          allowTaint: false,
          useCORS: false
        }).then((canvas) => { // canvas是个dom对象
          let save_url = canvas.toDataURL("image/png")
          this.imgbase = save_url
          this.visible = true
        })
      })
    },
    haddleTableCell(x, y) { // 点击单元格(x轴点,y轴点)
      this.loginVipFlow(() => {
        this.params.tag_arr = [y.id]
        this.list_params.tag_arr = [y.id]
        if (this.params.count_type == 1) {
          this.years = [parseInt(x), parseInt(x)]
          this.params.s_time = this.params.e_time = x
          this.list_params.s_time = this.list_params.e_time = x
        } else {
          this.years = [parseInt(x.year), parseInt(x.year)]
          this.params.s_time = this.params.e_time = x.year
          this.list_params.s_time = this.list_params.e_time = x.year
        }
        this.list_params.page = 1
        this.getMap()
        this.getList()
      })
    },
    spliceString(s, length) { // 截取字符串
      return s.substr(0, length) + '...'
    },
    transString(num) { // 类型转换
      if (typeof(num) == 'number') {
        return num + ''
      } else {
        return num
      }
    }
  },
  mounted() {
    const _this = this
    this.option.series[0].itemStyle.normal.color = function(params) {
      let color_stops = params.dataIndex === _this.curInt ? [{offset: 0,color: '#2f91a6'}, {offset: 1,color: '#2e76ad'}] : [{offset: 0,color: '#30D3EF'}, {offset: 1,color: '#31A8FD'}]
      return {
        type: 'linear',
        x: 0,
        y: 0,
        x2: 0,
        y2: 1,
        colorStops: color_stops
      }
    }
    this.option.series[1].symbolSize = function(item, params) {
      return params.dataIndex !== _this.curInt ? 4 : 8
    }
    this.getDivColors('#FFCB6A', '#E96350', 3)
    this.getMap()
    this.getList()
  },
  destroyed() {
    this.option = ''
    this.mychart = ''
  },
  watch: {
    theme_switch(val) {
      if (!this.spinShow && this.mychart) {
        if (this.params.tag_arr.length == 1) {
          this.echartChangeTheme4()
          this.mychart.setOption(this.option, true)
        }
        else if (this.params.tag_arr.length > 1) {
          this.echartChangeTheme6()
          this.mychart.setOption(this.arr_option, true)
        }
      }
    }
  }
}
</script>

<style lang="stylus" scoped>
@import '~styles/common.stylus'
@import '~styles/financing.stylus'
</style>
